<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <div class="navbar-brand">Chat Template</div>
      <div class=" ms-auto">
        <a class="btn btn-sm btn-outline-primary ms-auto" [class.disabled]="loading" [routerLink]="['/lo', company_uuid, 'chat-template', 'new']">&#43; Add Template</a>
      </div>
    </div>
</nav>
<hr/>
<div class="alert alert-danger" role="alert" *ngIf="error">{{ error }}</div>
<div class="row">
    <div class="col-md-3">
        <ul class="list-group">
            <li class="list-group-item" *ngFor="let list of lists">
                <a [routerLink]="['/lo', company_uuid, 'chat-template', list.uuid]" [class.pe-none]="loading" class="text-decoration-none w-100 d-inline-block">
                  <span [innerHTML]="(list.template | slice:0:30)"></span>
                  <span class="badge bg-secondary">{{ statusLabel(list.status) }}</span>
                </a>
            </li>
            <li class="list-group-item" *ngIf="lists.length == 0">No Data Available</li>
          </ul>
    </div>
    <div class="col-md-6 col-12">
        <p *ngIf="loadingTemplate" role="status">Loading template...</p>
        <div class="card" *ngIf="chat_template_uuid && !loadingTemplate && (chat_template_uuid === 'new' || data.uuid)">
            <div class="card-body">
                <form (ngSubmit)="submit()">
                    <quill-editor name="template" [format]="'html'" [(ngModel)]="data.template" [readOnly]="loading" [required]="true" [styles]="{minHeight: '250px'}"></quill-editor>
                    <div class="form-group">
                        <label for="status">Status</label>
                        <select class="form-control" id="status" name="status" [(ngModel)]="data.status" [disabled]="loading">
                            <option [ngValue]="1">Active</option>
                            <option [ngValue]="0">Inactive</option>
                            <option [ngValue]="2">Settle</option>
                        </select>
                        <small class="text-muted">Only Active templates appear in quick replies. Settle keeps the template as completed; you can activate it again later.</small>
                    </div>
                    
                    <button class="btn btn-primary mt-3" type="submit" [disabled]="loading">SAVE</button>
                    <button class="btn btn-outline-danger mt-3 ms-2" type="button" *ngIf="data.uuid" [disabled]="loading" (click)="deleteTemplate()">Delete Template</button>
                </form>
            </div>
        </div>
        
    </div>
</div>
